import {
  PatientAddress,
  Caregiver,
  EmergencyContact,
  PatientProfileBaseInfo,
  PrimaryCaregiver,
  SafetyConsideration,
} from '../../../../shared/models/patient.models';

export class SetExistingPatientFilters {
  static readonly type = '[PatientExisting] Set Filters';
  constructor(public filters: any) {}
}

export class SyncExistingPatientPerPage {
  static readonly type = '[PatientExisting] Sync Filters';
}

export class ResetExistingPatientFilters {
  static readonly type = '[PatientExisting] Reset Filters';
}

export class GetExistingPatientList {
  static readonly type = '[Patients existing] Get patients list';
}

export class GetPatientProfileById {
  static readonly type = '[Patients existing] Get patient by id';

  constructor(public id: string) {}
}

export class UpdateBaseInfoExistingPatient {
  static readonly type = '[Patients existing] Update base  patient by id';

  constructor(
    public patientId: string,
    public patient: PatientProfileBaseInfo,
  ) {}
}

export class UpdateAddressInfoExistingPatient {
  static readonly type = '[Patients existing] Update address patient by id';

  constructor(
    public patientId: string,
    public address: PatientAddress,
  ) {}
}

export class UpdatePrimaryCaregiverExistingPatient {
  static readonly type = '[Patients existing] Update primary caregiver patient by id';

  constructor(
    public patientId: string,
    public primaryCaregiver: PrimaryCaregiver,
  ) {}
}

export class UpdateEmergencyContactsExistingPatient {
  static readonly type = '[Patients existing] Update emergency contacts patient by id';

  constructor(
    public patientId: string,
    public emergency: EmergencyContact,
  ) {}
}

export class UpdateSafetyConsiderationExistingPatient {
  static readonly type = '[Patients existing] Update Safety Consideration patient by id';

  constructor(
    public patientId: string,
    public safetyConsideration: SafetyConsideration,
  ) {}
}

export class UpdateDCWCandidatesExistingPatient {
  static readonly type = '[Patients existing] Update DCW candidates patient by id';

  constructor(
    public patientId: string,
    public dcws: { caregivers: Caregiver[] },
  ) {}
}

export class ChangeMCOPatientProfile {
  static readonly type = '[Patients existing] Change patient MCO';

  constructor(
    public patientId: string,
    public mcoId: string | number,
  ) {}
}

export class GoToProfilePopUp {
  static readonly type = '[Patients existing] Error messages';

  constructor(
    public id: string,
    public messages: string | number,
  ) {}
}

export class UpdateInformalSupportExistingPatient {
  static readonly type = '[Patients existing] Update informal support patient by id';

  constructor(
    public patientId: string,
    public informalSupport: any,
  ) {}
}
